import { graphql, useStaticQuery } from "gatsby"
import React from "react"

const Socials = ({ facebook, instagram, alt }) => {
  const { footer } = useStaticQuery(
    graphql`
      query Socials {
        footer: datoCmsFooter {
          instagram
          facebook
          termsPdf {
            url
          }
          privacyPdf {
            url
          }
        }
      }
    `
  )
  return (
    <div className='socials small'>
      <div className='flex m-wrap t-wrap space-between m-gap-20'>
        <div className="m-100">
          <a className='link ul-link light' href={footer.instagram} target='_blank' rel='noreferrer'>
            Instagram
          </a>
          <a className='link ul-link ml20 light' href={footer.facebook} target='_blank' rel='noreferrer'>
            Facebook
          </a>
        </div>
        {alt && (
          <div className="t-100 m-100 t-mt20">
            <a className='link ul-link light' href={footer.privacyPdf.url} download target='_blank' rel='noreferrer'>
              Privacy Policy
            </a>
            <a className='link ul-link ml20 light' href={footer.termsPdf.url} download target='_blank' rel='noreferrer'>
              Terms & Conditions
            </a>
          </div>
        )}
      </div>
      <div className='mt15 m-show'>
        {alt ? (
          <div className='address mt40 small w-100'>
            4 Miles Street, Kirra, QLD 4225 <br />
            <br />
            <a className='ul-link link light' href='tel:(07) 5690 5000'>
              (07) 5690 5000
            </a>
            <p className='mt20'><a className='link' href='mailto:reservations@kirrapoint.com.au'>reservations@kirrapoint.com.au</a></p>
          </div>
        ) : (
          <a className='link ul-link inline light' href='https://www.google.com/maps/place/14A+Marine+Parade,+Coolangatta+QLD+4225' target='_blank' rel='noreferrer'>
            Marine Parade, Kirra Beach
          </a>
        )}
      </div>
    </div>
  )
}

export default Socials
